"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var collectionsRef_1 = require("common/db/collectionsRef");
var useSnapshotToSimpleDataSource_1 = __importDefault(require("common/hooks/useSnapshotToSimpleDataSource"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var useTitle_1 = __importDefault(require("../../hooks/useTitle"));
var defaultDevExtremeGridComponents_1 = __importDefault(require("../../utils/defaultDevExtremeGridComponents"));
var AddNewBudgetTemplateDialog_1 = __importDefault(require("./Dialogs/AddNewBudgetTemplateDialog"));
function BudgetTemplatesTable() {
    var _a = (0, react_1.useState)(false), modalState = _a[0], setModalState = _a[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)(t('budget.budgetTemplates'));
    var snapshot = (0, firestore_1.useCollection)(collectionsRef_1.budgetTemplatesRef)[0];
    var dataSource = (0, useSnapshotToSimpleDataSource_1.default)(snapshot);
    var columns = [
        {
            name: 'title',
            title: 'Template Name',
        },
        { name: 'description', title: 'Template Description' },
        { name: 'createdAt', title: 'Created At', getCellValue: function (r) { return r.createdAt.toDate().toLocaleDateString(); } },
        {
            name: 'id',
            title: 'Actions',
            key: 'id',
            filteringEnabled: false,
            getCellValue: function Actions(row) {
                return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("span", __assign({ style: {} }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/budget-templates/".concat(row.id), type: "primary", style: { margin: '0px 5px' } }, { children: t('common.view') })) })) }));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(AddNewBudgetTemplateDialog_1.default, { projectId: "template", modalState: modalState, setModalState: setModalState }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: dataSource, columns: columns }, { children: __spreadArray(__spreadArray([], (0, defaultDevExtremeGridComponents_1.default)({ groups: false, allowHidingColumns: false }), true), [(0, jsx_runtime_1.jsx)("div", { style: { padding: 16, paddingBottom: 0 } })], false) })) })] }));
}
exports.default = BudgetTemplatesTable;
